(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifGroupByTable', swifGroupByTable);

    /**
     * @ngdoc directive
     * @name swif.ui:swifGroupByTable
     * @module swif.ui
     * @restrict E
     * @description display a table from a group by query
    **/
    function swifGroupByTable(swif, $uibModal) {
        var d = {
            restrict: 'E',
            replace: true,
            scope: {
                options: '='
            },
            templateUrl: 'partials/ui/group_by_state_table.html'
        };
        d.link = function (scope) {
            var getGroupBy = function () {
                return scope.options.groupBy;
            };
            var getFilter = function () {
                var filter = angular.copy(scope.options.filter);
                var groupBy = getGroupBy();
                filter.fields = ['id', 'name', groupBy];
                swif.data.sortOn(filter, 'id', 'DESC');
                return filter;
            };
            scope.items = {};
            var groupRead = function(state) {
                var filter = getFilter();
                if (!_.isArray(state)) {
                    state = [state];
                }
                swif.data.addFilter(filter, 'state', 'in', state);
                return swif.data.groupRead(
                    scope.options.contentType, filter, getGroupBy()
                );
            };
            scope.$watch('options', function (newV) {
                if (newV) {
                    scope.groupBy = {};
                    scope.states = [];
                    _.forEach(newV.states, function (state) {
                        scope.states.push({_type: newV.contentType, state: state});
                        groupRead(state).then(function (data) {
                            _.forEach(data, function (groupBy) {
                                var label = groupBy[scope.options.groupBy][1];
                                var key = groupBy[scope.options.groupBy][0];
                                if (_.isUndefined(scope.groupBy[key])) {
                                    scope.groupBy[key] = {
                                        label: label,
                                        count: {},
                                        filter: {}
                                    };
                                }
                                scope.groupBy[key].count[state] = groupBy[scope.options.groupBy + '_count'];
                                scope.groupBy[key].filter[state] = {
                                    domain: groupBy.__domain
                                };
                            });
                        });
                    });
                } else {
                    scope.items = {};
                }
            }, true);
        };
        return d;
    }

})();
